var App = App || {};

App.ComponentSsTabs = (function ($) {
    'use strict';

    function Init() {
        $(".component-ssTabs").each(function () {

            const tabs = $(this).find("button[data-bs-toggle=\"tab\"]").toArray();
            tabs.forEach(t => {
                t.addEventListener('shown.bs.tab', event => {
                    const id = t.getAttribute("data-bs-target");
                    const tab = $(`${id}`);
                    tab.find(".item-ssTab-picture").addClass("animate__animated animate__fadeInDown");
                    tab.find(".item-ssTab-animation > div").each(function () {
                        $(this).addClass(`animate__animated animate__${$(this).data("animation")}`);
                    });
                })
            });
        });
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.ComponentSsTabs.Init();
});